export default "__VITE_ASSET__yw1umCyP__"